import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLogoSymbol = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 32,
	height: 36,
	xmlns: "http://www.w3.org/2000/svg",
	xmlSpace: "preserve",
	...props,
	children: /* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("title", { children: "Layer 1" }), /* @__PURE__ */ _jsxs("g", {
		id: "svg_13",
		children: [
			/* @__PURE__ */ _jsx("polygon", {
				id: "svg_14",
				fill: "#075A77",
				points: "8.800000190734863,26.299999237060547 6.899999618530273,28 6.899999618530273,18.100000381469727 8.800000190734863,16.299999237060547 ",
				className: "st1"
			}),
			/* @__PURE__ */ _jsx("polygon", {
				id: "svg_15",
				fill: "#5FDDBC",
				points: "14.200000762939453,26.299999237060547 12.300000190734863,28 12.300000190734863,15.399999618530273 14.200000762939453,13.699999809265137 ",
				className: "st2"
			}),
			/* @__PURE__ */ _jsx("polygon", {
				id: "svg_16",
				fill: "#6EB21F",
				points: "19.600000381469727,26.299999237060547 17.700000762939453,28 17.700000762939453,12.600000381469727 19.600000381469727,10.800000190734863 ",
				className: "st3"
			}),
			/* @__PURE__ */ _jsx("polygon", {
				id: "svg_17",
				fill: "#D8B403",
				points: "25.100000381469727,26.299999237060547 23.100000381469727,28 23.100000381469727,9.699999809265137 25.100000381469727,8 ",
				className: "st4"
			})
		]
	})] })
});
export default SvgLogoSymbol;
